import React from 'react'
import LazyLoad from 'react-lazyload'

function MUN2026() {
  return (
        <div class="col-12 row">
                    <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                      <article>
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/manager.jpg"
                            alt="St. Xavier’s School Bathinda"
                            class="sxumn_2021_msg img-fluid"
                          />
                        </LazyLoad>
                        <h3>Rev. Fr. Manager's Message</h3>
                        <p>
                          “O judgment! thou art fled to brutish beasts, and men have
                          lost their reason.”
                          <br />
                          —William Shakespeare
                          <br />
                          (Julius Caesar){" "}
                        </p>
                        <p>Dear Delegates, Faculty and Guests,</p>
                        <p>
                          The cutting satire drawn from Julius Caesar echoes through
                          the international political aisles, raising the alarm
                          against global diplomacy failures and their horrendous
                          ramifications. The international map has been brutally torn
                          into warzones and arbitrary political abductions, deadly
                          blockades around the Pacific and Gulf nations have
                          fractured the global order.{" "}
                        </p>
                        <p>
                          As our global community wades through a welter of
                          conflicting ideologies and crises of reason, the world looks
                          to the educational sector to prepare the next generation
                          with the robust ideals of ethical humanism. St. Xavier&apos;s
                          school, Bathinda, solemnly upholds this responsibility and
                          takes immense pride in launching the 10th edition of SXMUN
                          to inspire ethical international unison.This simulation is
                          an entreaty to reclaim &apos;reason&apos; and &apos;judgment&apos;, entailing
                          peace and harmony.{" "}
                        </p>
                        <p>
                          To contain the savage impulse, a revolution guided by
                          prudent leadership is called for. SXMUN invites young
                          diplomats-in-the-making to devise a blueprint sketching a
                          plan to combat complicated global crises, not with
                          hostility, but with synergy and cohesive strategies. May
                          the Muse of Judgment empower your deliberations, dialogues
                          and debates with logic, moving the conclave towards
                          impeccable peace.{" "}
                        </p>
                        <p>Warm regards,</p>
                        <p>
                          Rev. Fr. Eusebio Gomes
                          <br />
                          Manager
                          <br />
                          St. Xavier&apos;s School, Bathinda
                        </p>                        <div class="clr"></div>
                      </article>
                      <div class="clr"></div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                      <article>
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2023-principal.JPG"
                            alt="St. Xavier’s School Bathinda"
                            class="sxumn_2021_msg img-fluid"
                          />
                        </LazyLoad>
                        <h3>Rev. Fr. Principal's Message</h3>
                        <p>
                          “How dull it is to pause, to make an end,
                          <br />
                          To rust unburnish&apos;d, not to shine in use!”
                          <br />
                          — Tennyson
                          <br />
                          (Julius Caesar){" "}
                        </p>
                        <p>Dear Delegates, Faculty and Members of the Secretariat,</p>
                        <p>
                          While war is immoral to pacifists, it is non-moral to realists.
                          The ongoing debates surrounding this issue often raise
                          rhetoric against the moral relationships between nations,
                          while discussions on the consequential economic burden on
                          taxpayers frequently crash into mere conjecture. To answer
                          and conclude this oblivious commotion, SXMUN Edition X
                          propagates the theme of &apos;Unus Mundus&apos; – One World, One
                          Dialogue and a Shared Future.
                        </p>
                        <p>
                          As value education does not take place in isolation, it
                          requires a contextual setting of the actual world we live in.
                          The Xaverian spirit aligns seamlessly with the objective of
                          building calibre based on working knowledge against
                          formidable challenges. SXMUN– Edition X is all set to
                          assemble the best intellectual talent in a simulation of an
                          international consortium, aiming to uphold the value of
                          shared interests while challenging the neo-colonial order.
                        </p>
                        <p>
                          St. Xavier&apos;s academia takes pride in witnessing classrooms
                          turn into the Security Council, wherein 15-year-olds,
                          powered by cognitive abilities, demonstrate inspiring
                          resilience. They ride the troughs and peaks of a
                          long-drawn-out series of deliberations, culminating in the
                          final drafting of resolutions. The decennial acknowledges
                          the celebratory validation of incessant empirical discourse,
                          clubbed with the meritorious administrative skills
                          demonstrated by the Secretariat and Organizing Committee
                          for ten glorious years.
                        </p>
                        <p>
                          In an effort to replenish the ethical capital currently
                          being eroded by acts of commission and omission in
                          executing the United Nations charter and by the abuse of
                          power afflicting the international order, SXMUN – Edition X,
                          in compliance with the theories of consequentialism,
                          deontology and virtue ethics, is set to unearth the complex
                          relationship between morality and international diplomacy.
                          The simulation augments the inevitable discussion on
                          humanitarian intervention, exploring membership in
                          international agencies like NATO and the justification of
                          sanctions to expose suspicious, self-serving agendas.
                        </p>
                        <p>
                          It is the Xaverian austere pursuit to expose the bloody
                          business of conflict, where a severed carotid artery sends
                          jitters down one&apos;s spine and where the aftermath leaves
                          behind orphans, widows, the homeless and the starving, with
                          epidemics filling graves faster than the war itself.
                        </p>
                        <p>Uphold the cause of humanity!</p>
                        <p>Warm regards,</p>
                        <p>
                          Rev. Fr. Cidloy Furtado
                          <br />
                          Principal
                          <br />
                          St. Xavier&apos;s School, Bathinda
                        </p>                        <div class="clr"></div>
                      </article>
                      <div class="clr"></div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                      <article>
                        <h3>Secretary General's Message</h3>
                        <p>
                          {" "}
                          “When the power of love overcomes the love of power, the
                          world will know peace.” — <b>Jimi Hendrix</b>{" "}
                        </p>{" "}
                        <p> Greetings everyone, </p>{" "}
                        <p>
                          {" "}
                          We live in an era where hatred is louder than reason and
                          silence often walks hand in hand with complicity. The
                          world doesn’t need another war. What it needs is a
                          generation that isn’t afraid to speak, to question and to
                          act.{" "}
                        </p>{" "}
                        <p>
                          {" "}
                          This year, the theme of SXMUN is more than just a phrase —
                          it's a reflection of our times and a challenge to our
                          conscience: ECHOES: A Voracious, Vociferous, Vehement Call
                          for Peace. Peace today must be more than a diplomatic
                          ideal. It must be a demand. Voracious, because we must
                          hunger for truth and justice in an age of misinformation.
                          Vociferous, because silence has never protected the
                          oppressed. Vehement, because our belief in peace should be
                          fierce, not fragile.{" "}
                        </p>{" "}
                        <p>
                          {" "}
                          Since its inception in 2017, St. Xavier’s Model United
                          Nations has stood as a space for students to think
                          critically and feel deeply. SXMUN 2025 continues that
                          legacy — now more urgent than ever. We are not just
                          delegates in a committee room; we are the inheritors of a
                          world in crisis and the architects of what comes
                          next.{" "}
                        </p>{" "}
                        <p>
                          {" "}
                          We will debate, we will dissent and we will disagree but
                          through that, we will grow. because peace isn't passive.
                          It’s built word by word, choice by choice. Let SXMUN be a
                          space where empathy meets action, where opinions turn into
                          purpose and where we echo not the noise of division
                          but{" "}
                        </p>{" "}
                        <p> the sound of hope. </p>{" "}
                        <p>
                          {" "}
                          The time to wait is over. The time to speak is now. Let
                          the echoes begin.{" "}
                        </p>
                        <p>
                          <strong> Warm Regards,</strong>
                          <br />
                          Harshmeet Sarwara <br />
                          (Secretary General, SXMUN'25){" "}
                        </p>
                        <div class="clr"></div>
                      </article>
                      <div class="clr"></div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                      <article>
                        <h3>Director General's Message</h3>
                        <p>
                          “Peace cannot be kept by force; it can only be achieved by
                          understanding.” <b>– Albert Einstein</b>{" "}
                        </p>{" "}
                        <p>
                          {" "}
                          <b>Dear Delegates,</b>{" "}
                        </p>{" "}
                        <p>
                          It gives me great pleasure to welcome you to this year’s
                          edition of St. Xavier’s Model United Nations, where we
                          gather under a theme that is bold, intense and deeply
                          meaningful: ECHOES – Voracious, Vociferous, Vehement: A
                          Call for Peace.{" "}
                        </p>{" "}
                        <p>
                          In today’s world, where conflicts dominate headlines and
                          polarization grows every day, peace often feels like a
                          distant dream. But peace isn’t passive. It’s not the
                          silence after war — it is the active pursuit of justice,
                          dialogue and understanding. That’s what this year’s theme
                          is all about.{" "}
                        </p>{" "}
                        <p>
                          To be voracious means having a strong desire — a hunger
                          for change. As young leaders and future diplomats, your
                          desire for peace must be more than an idea. It must be a
                          driving force behind every word you speak and every
                          solution you offer.{" "}
                        </p>{" "}
                        <p>
                          To be vociferous means being bold in speech — not afraid
                          to raise your voice for those who can’t. In committee, you
                          must speak with purpose, stand up for your beliefs and
                          give space to voices that are often ignored in global
                          discussions.{" "}
                        </p>{" "}
                        <p>
                          To be vehement means to believe in something with passion
                          and emotion. Your presence here isn’t just for debate —
                          it’s for impact. Let your resolutions carry the weight of
                          real empathy, real urgency, and a real will to build
                          peace.{" "}
                        </p>{" "}
                        <p>
                          This conference is offers growth, awareness and
                          empowerment. The problems you’re discussing are real. The
                          voices you represent are real. And the skills you’re
                          building are what the world desperately needs — the
                          ability to listen, to lead and to build peace even in
                          disagreement.{" "}
                        </p>{" "}
                        <p>
                          Let your voices echo beyond these rooms. Let your ideas
                          challenge the norm. And above all, let your actions
                          reflect the kind of world you wish to live in.{" "}
                        </p>{" "}
                        <p>
                          Wishing you all a meaningful, impactful and empowering MUN
                          experience.
                        </p>
                        <p>
                          <strong>Regards </strong>
                          <br />
                          Himankshi Gupta <br />
                          (Director General, SXMUN'25)
                        </p>
                        <div class="clr"></div>
                      </article>
                      <div class="clr"></div>
                    </div>
                  </div>
  )
}

export default MUN2026